import { Step } from '~/store/types/updateApplication';

export const getStepName = (stepName: Step) => {
  switch (stepName) {
    case 'enable_banking':
      return 'UpdateApplication.EnableBanking';
    case 'guarantors':
      return 'UpdateApplication.Guarantors';
    default:
      return '';
  }
};
